import React from 'react';
import { connect } from 'react-redux';
import LocalizedStrings from 'react-localization';
import Loader from 'react-loader';
import CustomersClaims from '../../components/CustomersClaims/index.es6';
import * as actions from './actions.es6';
import * as globalActions from '../Main/actions.es6';
import { updateCurrentLanguage } from '../../lib/languageUtils.es6';
import { localisedText } from '../../lib/localisation.es6';

export class ClaimsPayable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      labels: new LocalizedStrings(localisedText),
    };
  }

  componentWillMount() {
    this.props.dispatch(actions.payableClaimsRequest());
    this.updateLanguage();
    this.props.dispatch(globalActions.hideCustomerBar());
  }

  componentDidUpdate() {
    this.updateLanguage();
  }

  updateLanguage() {
    updateCurrentLanguage(
      this.props.globalData.language,
      'ClaimsPayable',
      this.state.labels
    );
  }

  render() {
    const labels = this.state.labels;
    return (
      <Loader loaded={!this.props.claimData.loader} color="#ff834f">
        <CustomersClaims
          claims={this.props.claimData.payableClaimList}
          title={labels.claimsPayable}
          columnWidth="col-md-12"
          showMore={false}
        />
      </Loader>
    );
  }
}

export default connect(state => ({
  claimData: state.payableClaimsList,
  globalData: state.global,
}))(ClaimsPayable);
